<template>
  <div id="sidebar" class="sidebar" :style="{ backgroundColor: coloreSfondo }">
    <SidebarHeader />
    <SidebarForm />
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul v-if="navItems" class="nav">
        <template v-for="item in navItems">
          <template v-if="item.title">
            <SidebarNavTitle
              :key="item.name"
              :name="item.name"
              :classes="item.class"
              :wrapper="item.wrapper"
              :style="{ color: coloreTitoli }"
            />
          </template>
          <template v-else-if="item.divider">
            <SidebarNavDivider :key="item.name" :classes="item.class" />
          </template>
          <template v-else>
            <template v-if="item.children">
              <!-- First level dropdown -->
              <SidebarNavDropdown
                :key="item.name"
                :name="item.name"
                :state="item.state"
                :icon="item.icon"
              >
                <template v-for="childL1 in item.children">
                  <template v-if="childL1.children">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown
                      :key="childL1.name"
                      :name="childL1.name"
                      :state="childL1.state"
                      :icon="childL1.icon"
                    >
                      <li v-for="childL2 in childL1.children" :key="childL2.name" class="nav-item">
                        <SidebarNavLink
                          :name="childL2.name"
                          :state="childL2.state"
                          :icon="childL2.icon"
                          :badge="childL2.badge"
                          :variant="item.variant"
                          :project-id="item.projectId"
                          :modality="item.modality"
                        />
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :key="childL1.name" :classes="item.class">
                      <SidebarNavLink
                        :name="childL1.name"
                        :state="childL1.state"
                        :icon="childL1.icon"
                        :badge="childL1.badge"
                        :variant="item.variant"
                        :project-id="item.projectId"
                        :modality="item.modality"
                      />
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :key="item.name" :classes="item.class">
                <SidebarNavLink
                  :name="item.name"
                  :state="item.state"
                  :icon="item.icon"
                  :badge="item.badge"
                  :variant="item.variant"
                  :project-id="item.projectId"
                  :modality="item.modality"
                />
              </SidebarNavItem>
            </template>
          </template>
        </template>
        <div class="logout_spate">
          <button
            :style="{
              backgroundColor: coloreBottone,
              borderColor: coloreBordoBottone,
              color: coloreTestoBottone
            }"
            type="submit"
            name="loginForm"
            value="check"
            class="btn btn-lg btn-success"
            @click="onClickLogout"
          >
            Logout
          </button>
        </div>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter />
    <!--<SidebarMinimizer/>-->
  </div>
</template>
<script>
import SidebarFooter from "./SidebarFooter";
import SidebarForm from "./SidebarForm";
import SidebarHeader from "./SidebarHeader";
import SidebarNavDivider from "./SidebarNavDivider";
import SidebarNavDropdown from "./SidebarNavDropdown";
import SidebarNavLink from "./SidebarNavLink";
import SidebarNavTitle from "./SidebarNavTitle";
import SidebarNavItem from "./SidebarNavItem";
import Cookies from "js-cookie";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Sidebar",
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      coloreSfondo: "",
      coloreTitoli: "",
      coloreBottone: "",
      coloreBordoBottone: "",
      coloreTestoBottone: ""
    };
  },
  computed: {
    ...mapGetters(["userLevel", "selectProfile"])
  },
  mounted: function() {
    var that = this;
    that.getColoriSidebarAction().then(function(data) {
      that.coloreSfondo = data[0];
      that.coloreTitoli = data[2];
      that.coloreBottone = data[3];
      that.coloreBordoBottone = data[5];
      that.coloreTestoBottone = data[6];
    });
  },
  methods: {
    ...mapActions("_colorsModule", ["getColoriSidebarAction"]),
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    },
    onClickLogout() {
      Cookies.remove("loginToken");
      // reload page
      this.$router.push("/login").catch(()=>{});
    }
  }
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}

.logout_spate {
  padding: 0 16px;
  margin: auto 0 16px;
}
.logout_spate > .btn {
  width: 100%;
}

.el-radio__input.is-disabled.is-checked .el-radio__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>
